(() => {
  function bindCart() {
    const form = document.getElementById('HACCartForm');
    if (!form || form.dataset.giftGuardBound) return;
    const inputs = Array.from(form.querySelectorAll('[name="updates[]"][data-hac-gift]'));
    const checkout = form.querySelector('[name="checkout"]');
    const notice = document.getElementById('HACGiftPurchaseNotice');
    const error = document.getElementById('HACGiftPurchaseError');
    if (!checkout || !notice || !error) return;
    form.dataset.giftGuardBound = 'true';
    function check() {
      let gift = 0;
      let other = 0;
      for (const input of inputs) {
        const quantity = Number(input.value);
        if (!Number.isFinite(quantity) || quantity < 0 || !Number.isInteger(quantity)) continue;
        if (input.dataset.hacGift === 'true') gift += quantity;
        else other += quantity;
      }
      const invalid = gift > 1 || (gift > 0 && other > 0);
      notice.hidden = gift === 0;
      error.hidden = !invalid;
      checkout.disabled = invalid;
      return invalid;
    }
    form.addEventListener('input', check);
    form.addEventListener('change', check);
    form.addEventListener('submit', (event) => {
      if (event.submitter && event.submitter.name !== 'checkout') return;
      if (check()) {
        event.preventDefault();
        error.focus();
      }
    });
    check();
  }
  bindCart();
  document.addEventListener('shopify:section:load', bindCart);
})();